module.exports = __webpack_public_path__ + "static/media/apartment-building-city-svgrepo-com.65e143b8.svg";